import { render, staticRenderFns } from "./account-nationality.vue?vue&type=template&id=e52d8358&"
import script from "./account-nationality.vue?vue&type=script&lang=js&"
export * from "./account-nationality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports